<ng-container>
  <div class="external-id" *ngIf="isDuplicateExternalId$ | async">
    <mat-error>
      {{ 'COMMON.AUXILIARY_DATA.IDENTIFIER_DUPLICATE_MESSAGE' | translate }}
    </mat-error>
  </div>
  <div class="external-id">
    <span>
      {{ 'COMMON.AUXILIARY_DATA.EXTERNAL_IDENTIFIER' | translate }}
      <mat-icon [glxyPopover]="smallPopover" (mouseenter)="showSmallPopover()" (mouseleave)="hideSmallPopover()">
        info_outline
      </mat-icon>
      : {{ externalIdFormControl.value }}
    </span>
    <a [glxyPopover]="externalIdPopover" (click)="showExternalIdPopover()">
      {{ editExternalIdText | translate }}
    </a>
  </div>
  <glxy-popover
    #externalIdPopover
    [maxWidth]="'320px'"
    [maxHeight]="'auto'"
    [isOpen]="isExternalIdPopoverVisible"
    [hasBackdrop]="false"
    [showBackdrop]="false"
    [hasArrow]="true"
    [keepOnScreen]="false"
    [padding]="'large'"
    [positions]="[PopoverPositions.BottomRight]"
  >
    <div class="text-bottom-spacing strong-warning-text">
      {{ 'COMMON.AUXILIARY_DATA.EXTERNAL_IDENTIFIER_WARNING' | translate }}
    </div>
    <mat-form-field class="new-external-id">
      <input
        type="text"
        matInput
        [formControl]="externalIdNewValue"
        (onchange)="externalIdNewValue.updateValueAndValidity()"
      />
      <mat-error *ngIf="externalIdNewValue.hasError('pattern')">
        {{ 'COMMON.AUXILIARY_DATA.IDENTIFIER_VALIDATION_MESSAGE' | translate }}
      </mat-error>
      <mat-error *ngIf="externalIdNewValue.hasError('duplicate')">
        {{ 'COMMON.AUXILIARY_DATA.IDENTIFIER_DUPLICATE_MESSAGE' | translate }}
      </mat-error>
    </mat-form-field>
    <glxy-popover-actions>
      <button
        mat-flat-button
        color="primary"
        (click)="setExternalId()"
        [disabled]="externalIdNewValue.pristine || externalIdNewValue.invalid || isCheckingDuplicate"
        class="save-external-id-button"
      >
        {{ 'COMMON.ACTION_LABELS.SAVE' | translate }}
      </button>
      <button mat-stroked-button (click)="cancelExternalId()">
        {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
      </button>
    </glxy-popover-actions>
  </glxy-popover>

  <glxy-popover
    #smallPopover
    [maxWidth]="'320px'"
    [maxHeight]="'auto'"
    [isOpen]="isSmallPopoverVisible"
    [hasBackdrop]="false"
    [showBackdrop]="false"
    [hasArrow]="true"
    [keepOnScreen]="false"
    [padding]="'large'"
    [positions]="[PopoverPositions.BottomRight]"
  >
    <div>
      {{ 'COMMON.AUXILIARY_DATA.EXTERNAL_IDENTIFIER_DESCRIPTION' | translate }}
    </div>
  </glxy-popover>
</ng-container>
